import React, { useEffect } from "react";
import useAxios from "axios-hooks";
import TextField from "../../../../Forms/TextField";
import UploadButton from "../../../../Forms/UploadButton";
import { useFormikContext } from "formik";
import DropDown from "../../../../Forms/DropDown";
import { DatePicker } from "../../../../Forms/DatePicker";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";
import FluentSelect from "../../../../Forms/FluentSelect";

function formatStringAsSlug(string) {
    return string && string.toLowerCase().split(" ").join("-");
}

const BasicInfoFields = ({ disabled, audioId }) => {
    const { setFieldValue, getFieldProps } = useFormikContext();
    const statusOptions = [{id: "DR", name:"Draft"}, {id:"PB",name:"Published"}]
    const [{ data: instructors, loading: loadingInstructors }, getAuthors] = useAxios({ url: `resources/audio/authors`, method: "get",});

    const [{ data }, uploadAudio] = useAxios(
        { url: `resources/audio/upload-audio`, method: "post", headers: { 'content-type': 'multipart/form-data' }},
        { manual: true },
        );
    
    const audioChanged = async (e, audioLength) => {
        if (e.target.value) {

            const data = new FormData();
            data.append('Audio', e.target.files[0]);
            data.append('AudioId', audioId)
            data.append('AudioLength', audioLength);
            data.append("Slug", getFieldProps("slug").value);
            data.append("AuthorSlug", getSelectedAuthorName());

            uploadAudio({ data})
            .then( (res) => {
                updateAudioInstructorFiles(`audioUrl${audioLength}Min`, res.data)
            })
        }
    }

    const getSelectedAuthorName = () => {
        var selectedAuthorId = getFieldProps("selectedAuthorId").value;
        var selectedAuthor= getFieldProps("audioInstructors").value.find(x => x.authorId === selectedAuthorId);
        return selectedAuthor.name ? selectedAuthor.name.replaceAll(' ', '') : selectedAuthor.firstName + selectedAuthor.lastName;
    }

    const updateAudioInstructorFiles = (name, url) => {
        var selectedAuthorId = getFieldProps("selectedAuthorId").value;
        var selectedAuthorIndex = getFieldProps("audioInstructors").value.findIndex(x => x.authorId === selectedAuthorId);

        setFieldValue(`audioInstructors[${selectedAuthorIndex}][${name}]`, url);

        setFieldValue(name, url);
    }

    const syncAudioInstructors = () => {
        var audioInstructors = getFieldProps("audioInstructors").value;
        var audioInstructorsTmp = getFieldProps("audioInstructorsTmp").value;
        
        //remove deleted instructors
        var filteredInstructors = audioInstructors.filter(x => audioInstructorsTmp.findIndex(y => y.authorId === x.authorId) !== -1);

        //add inserted instructors
        var newInstructors = audioInstructorsTmp.filter(x => audioInstructors.findIndex(y => y.authorId === x.authorId) === -1);
        filteredInstructors.push(...newInstructors);

        setFieldValue("audioInstructors", filteredInstructors);
    }

    useEffect(() => {
        //Map audio Instructors for fluend select on initial load.
        if (!loadingInstructors && instructors) {
            var audioInstructors = getFieldProps("audioInstructors").value;
            var filteredInstructors = instructors.filter(x => audioInstructors.findIndex(y => y.authorId === x.authorId) !== -1);
            setFieldValue("audioInstructorsTmp", filteredInstructors);
        }
    },[loadingInstructors])

    useEffect(() => {
        if (!loadingInstructors) {
            syncAudioInstructors();
        }
    }, [getFieldProps("audioInstructorsTmp").value])

    return (
        <div className="mt-1">
            <TextField
                label="Title"
                name="title"
                required
                onChange={(e, newValue) => {
                    setFieldValue("title", newValue);
                    setFieldValue("slug", formatStringAsSlug(newValue));
                }}
            />
            <TextField
                disabled={disabled}
                label="Slug"
                name="slug"
                required
                description="The url that will be used to visit the audio"
            />
            <TextField
                label="Description"
                name="description"
                onChange={(e, newValue) => {
                    setFieldValue("description", newValue);
                }}
            />
            <ChoiceGroup label="Publish Status" name="publishStatus" options={statusOptions && statusOptions.map(status => ({ key: status.id, text: status.name }))} required/>
            <DatePicker label="Publish Date" name="publishDate" allowTextInput required/>

            <FluentSelect
                options={instructors && instructors.map(x => ({value: x , label: x.name}))}
                disabled={loadingInstructors}
                name="audioInstructorsTmp"
                isMulti
                label="Add Meditation Instructors"
            />
            
            {getFieldProps("audioInstructorsTmp").value.length > 0 && 
            <>
                <DropDown 
                    label="Choose Meditation Instructor For Audio Files"
                    placeholder="Select an instructor"
                    options={ getFieldProps("audioInstructorsTmp").value.map((x,i) => ({key: x.authorId, text: x.name}))}
                    disabled={loadingInstructors}
                    name="selectedAuthorId"
                    onChange={(e, v) => {
                        setFieldValue("selectedAuthorId", v.key);

                        let audioInstructor = getFieldProps("audioInstructors").value.find(x => x.authorId === v.key)

                        setFieldValue("audioUrl5Min", audioInstructor.audioUrl5Min)

                        setFieldValue("audioUrl10Min", audioInstructor.audioUrl10Min)

                        setFieldValue("audioUrl20Min", audioInstructor.audioUrl20Min)

                    }}
                    required
                />
                {!isNaN(getFieldProps("selectedAuthorId").value) && 
                <>
                    <TextField
                        label="5 Min Meditation"
                        name={`audioUrl5Min`}
                        className="mt-0"
                        placeholder="If entering manually, enter URL with 'https://cdn.igrad.com/'/' domain" 
                        onChange= {(e) => {
                            updateAudioInstructorFiles("audioUrl5Min", e.target.value)
                        }}
                        required
                    />
                    <UploadButton name="5minaudio" accept="audio/*" label={"Upload 5 Min Meditation"} onChange={async (e) => { audioChanged(e, 5) }}/>

                    <TextField
                        label="10 Min Meditation"
                        name={`audioUrl10Min`}
                        placeholder="If entering manually, enter URL with 'https://cdn.igrad.com/'/' domain" 
                        onChange= {(e) => {
                            updateAudioInstructorFiles("audioUrl10Min", e.target.value)
                        }}
                    />
                    <UploadButton name="10minaudio" accept="audio/*" label="Upload 10 Min Meditation" onChange={async (e) => { audioChanged(e, 10) }}/>

                    <TextField
                        className=""
                        label="20 Min Meditation"
                        name={`audioUrl20Min`}
                        placeholder="If entering manually, enter URL with 'https://cdn.igrad.com/'/' domain" 
                        onChange= {(e) => {
                            updateAudioInstructorFiles("audioUrl20Min", e.target.value)
                        }}
                    />
                    <UploadButton name="20minaudio" accept="audio/*" label="Upload 20 Min Meditation" onChange={async (e) => { audioChanged(e, 20) }}/>
                </>}
            </>}
        </div>
    );
};

export default BasicInfoFields;
